<template>
  <div class="mt-5" v-if="!isLoading">
    <div
      class="alert alert-primary py-3 d-flex justify-content-between align-items-center"
      role="alert"
    >
      <p class="mb-0">{{ $t("texto-grupo-cria-info") }}.</p>
    </div>

    <!-- grupos de gria - o sea perros con criador >= 3  -->
    <div class="row" v-if="!compHayGruposWeb">
      <div class="col-md-12">
        {{ $t("texto-no-perros-suficientes-grupo-cria") }}
      </div>
    </div>
    <!--  {{ gruposApi }} -->
    <div
      class="row"
      v-for="(grupo, index) in gruposApi"
      :key="`${index}__${grupo}`"
    >
      <!-- {{grupo}} {{index}} -->
      <div class="col-12">
        <div class="card mb-3 pb-0 mb" v-if="grupo">
          <div class="card-header">
            {{ razaNombre(index) }}
          </div>
          <div v-for="(c, n) in grupo" :key="n + index">
            <!--  {{ c[0].criadores }}     -->
            <div class="card-body" v-if="c.length > 2">
              <div class="row" v-for="dog in c" :key="`${dog.dog_id}`">
                <!--   {{ dog }}  -->
                <div class="col-8 pr-1">
                  {{ dog.dog_id | nombrePerro(listaPerros) }}
                </div>
                <div class="col-4 pl-1">
                  <!-- comprobamos si tenemos suficientes perros para hacer varios grupos -->
                  <span v-for="i in Math.ceil(c.length / 5)" :key="i">
                    <toggle-button
                      class="ml-1"
                      :value="false"
                      :width="85"
                      :height="26"
                      :sync="true"
                      tag="checkbox"
                      v-model="dog.selected[i - 1]"
                      :color="checkColorGrupo(index, c[0].criadores, i)"
                      :name="dog.dog_id.toString()"
                      :labels="{
                        checked: `${$t('grupo')} ${i}`,
                        unchecked: `${$t('grupo')} ${i}`,
                      }"
                      @change="
                        cambiarOpcion(
                          $event,
                          index,
                          c[0].criadores,
                          dog.dog_id,
                          i
                        )
                      "
                    />
                  </span>
                </div>
              </div>
            </div>
            <hr class="py-0 my-0" />
          </div>
        </div>
      </div>
    </div>

    <div class="card mt-2" v-if="tmpInscritos.length > 0">
      <div class="card-header">
        {{ $t("inscritos") }}
      </div>
      <div class="card-body pt-0">
        <table class="table mb-0 mt-0 pt-0">
          <tr v-for="(ins, n) in tmpInscritos" :key="`${ins.raza}_${n}`">
            <td class="text-left">
              {{ `${ins.raza}_${n}` }}
              <span v-for="p in ins.dogs" :key="p">
                {{ p | nombrePerro(listaPerros) }}<br
              /></span>
            </td>
            <td class="text-right align-bottom">
              <b>{{ ins.importe }} €</b>
            </td>
          </tr>
        </table>
      </div>
    </div>

    <!--     {{ tmpInscritos }}  -->
    <!-- perros sin criador -->
    <!--   <div class="row" v-if="listaInscritosSinCriador.length > 0">
      <div class="col-md-12">
        <p>DEBUG: Perros inscritos sin criador</p>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12" v-for="p in listaInscritosSinCriador" :key="p">
        <p class="small-text text-left mb-1">
          {{ p | nombrePerro(listaPerros) }} {{ p }}
        </p>
      </div>
    </div> -->
  </div>
</template>

<script>
import Vue from "vue";
import { mapActions } from "vuex";
import ToggleButton from "vue-js-toggle-button";
import { inscriptionMixin } from "@/_mixins/Inscription-mix";
Vue.use(ToggleButton);

import _ from "lodash";
export default {
  name: "ins-grupo-cria-comp",
  props: ["datos", "datosNormalizados"],
  mixins: [inscriptionMixin],
  data: () => ({
    isLoading: true,
    listaCriadores: [],
    listaInscritosSinCriador: [],
    grupoCria: {},
    gruposApi: [],
    misCriadores: [],
    listaPerros: [],
    tarifas: [],
    tmpInscritos: [],
  }),
  methods: {
    ...mapActions("inscription", ["getListaGrupoCria"]),
    /* para recoger la raza del perro */
    razaNombre(razaId) {
      //filtramos los datos dependiendo del idioma de la page
      const lang = this.$i18n.locale;
      const perros = this.datos.expoData.breeds_all;

      const razaNombre = perros.find((p) => p.id === parseInt(razaId))
        .translations;
      const tmp = razaNombre.find((r) => r.locale === lang);

      let res = tmp.name;
      if (tmp.variety !== "") res += " " + tmp.variety;
      if (tmp.subvariety !== "") res += " " + tmp.subvariety;
      return res;
    },
    /* crear la lista de inscritos dinámica */
    cambiarOpcion(event, raza, grupo, dogId, grupoInscrito) {
      let tmp = this.gruposApi[raza][grupo].find((g) => g.dog_id === dogId);

      if (event.value === true) {
        //contamos si en el grupo hay ya 5 parano permitir mas de 5
        const ftr = this.gruposApi[raza][grupo].filter(
          (g) => g.grupoInscrito === grupoInscrito
        );
        if (ftr.length > 4) {
          tmp.grupoInscrito = null;
          tmp.selected[grupoInscrito - 1] = false;
          return;
        }
        tmp.grupoInscrito = grupoInscrito;
      } else {
        tmp.grupoInscrito = null;
      }

      //actualizamos todas las posibles opciones al pasar otro grupo si existe a true
      if (tmp.selected.length > 0) {
        tmp.selected.forEach((s, n) => {
          if (n !== grupoInscrito - 1) {
            tmp.selected[n] = false;
          }
        });
      }
      this.generarDatosEmitir();
      // console.log(event, raza, grupo, dogId, tmp);
    },
    /* generar los datos para inscriptions-new */
    generarDatosEmitir() {
      //clonamos los datos
      const grupos = _.cloneDeep(this.gruposApi);
      let newIn = [];

      for (const raza in grupos) {
        const grupo = grupos[raza];
        for (const cri in grupo) {
          const tmp = grupo[cri];
          const inscritos = tmp.filter((t) => t.grupoInscrito !== null);
          const unicos = _.uniq(inscritos.map((i) => i.grupoInscrito));

          // console.log("el grupo criadores", cri, inscritos);
          //si hay al menos 3 creamos los grupos si es necesario
          if (inscritos.length > 2) {
            const claseTarifa = 10;
            const nacionalidad = this.datos.userData.nationality;

            const tNormalizada = this.mixNormalizarTarifa(this.tarifas);
            const tarifaFiltrada = this.mixgenerarTarifaIns(
              this.tarifas,
              raza,
              nacionalidad,
              claseTarifa
            );
            unicos = unicos.sort((a, b) => a - b);
            console.log("tarifa", tarifaFiltrada, unicos);
            //iteramos por los grupos encontrados
            let contador = 0;
            unicos.forEach((u) => {
              const numInsG = inscritos.filter((i) => i.grupoInscrito === u);

              if (numInsG.length > 2) {
                contador++;
                const maxTar = tarifaFiltrada.length;
                const idx = contador <= maxTar ? contador - 1 : maxTar - 1;
                const socio = this.socio === 1 ? true : false;
                const filtro = tarifaFiltrada[idx];
                console.log(filtro, idx, maxTar, contador);
                const importe = socio ? filtro.price_partner : filtro.price;

                const insTemp = {
                  raza: raza,
                  grupoCriador: cri,
                  dogs: numInsG.map((i) => i.dog_id),
                  grupoNum: u,
                  importe: importe,
                  contador: contador,
                  tarifa_id: filtro.tarifa_id,
                  expo_rate_type_id: filtro.expo_rate_type_id,
                  expo_date_inscription_id: filtro.expo_date_inscription_id,
                  expo_prices_id: filtro.expo_prices_id,
                };

                newIn.push(insTemp);
              }
            });
          }
        }
      }

      this.$emit("emitActualizarDatosCria", newIn);
      this.tmpInscritos = newIn;
    },

    cambiarOpcion_old(n, idx, dogId, grupo) {
      const val = n.value;
      const g = this.gruposApi[grupo - 1].grupos[idx];
      const tmp = this.gruposApi[grupo - 1].grupos;
      const status = this.gruposApi[grupo - 1].status;
      //comprobamos si existen ya 5 en el grupo para anular la peticion
      if (g.length > 4) {
        status[idx][dogId] = false;
        return;
      }

      //si el valor es true debemos recorrer los demás grupos para ponerlos a false
      if (val === true) {
        Object.keys(tmp).forEach((key) => {
          if (parseInt(key) !== idx) {
            //console.log(key, idx, tmp[key].indexOf(dogId));
            if (tmp[key].indexOf(dogId) !== -1) {
              tmp[key].splice(tmp[key].indexOf(dogId), 1);
              status[key][dogId] = false;
            }
          }
        });
        g.push(dogId);
      } else {
        //lo eliminamos de todos los grupos
        Object.keys(tmp).forEach((key) => {
          if (tmp[key].indexOf(dogId) !== -1) {
            //  console.log("elimino dog id", dogId, key)
            tmp[key].splice(tmp[key].indexOf(dogId), 1);
            status[key][dogId] = false;
            return;
          }
        });
      }
    },
    moverAGrupo_old(dogid, grupoData) {
      let agrupado = false;
      console.log("movemos a grupo el id", dogid, grupoData);
      const grupo = this.grupoCria;
      //si no existe el grupo lo creamos nuevo y asignamos el perro
      if (!grupo[grupoData.grupoCriador]) {
        // console.log("no existe el grupo y lo creamos");
        grupo[grupoData.grupoCriador] = [dogid];
        // console.log(grupo[grupoData.grupoCriador]);
      } else {
        let gActual = grupo[grupoData.grupoCriador];

        //si hay menos de 5 lo podemos añadir
        if (gActual.length < 5) {
          if (gActual.indexOf(dogid) === -1) {
            gActual.push(dogid);
            //  console.log("existe el grupo y actualizamos", gActual);
            agrupado = true;
          } else {
            gActual.splice(gActual.indexOf(dogid), 1);
            if (gActual.length === 0) {
              //  console.log("elimino el grupo de cria....");
              delete this.grupoCria[grupoData.grupoCriador];
            }
            // console.log("existe el grupo y lo eliminamos", gActual);
          }
        }
      }
    },
    checkColorGrupo(raza, grupo, grupoInscrito) {
      // console.log(raza, grupo, this.gruposApi[raza][grupo]);
      // return "#CCCCCC";
      if (!this.gruposApi) {
        return "#CCCCCC";
      }
      const tmp = this.gruposApi[raza][grupo].filter(
        (g) => g.grupoInscrito === grupoInscrito
      );
      //const tmp = _.cloneDeep(this.gruposApi[grupo - 1].grupos[idx]);
      const cont = tmp.length;
      if (cont > 2 && cont < 6) {
        return "#008000";
      } else if (cont <= 2) {
        return "orange";
      } else {
        return "#CCCCCC";
      }
    },
    generarListaCriadores() {
      this.datosNormalizados.forEach((dog) => {
        const dogData = this.datos.userData.dogs.filter(
          (x) => x.id === dog.dogId
        )[0];
        //si el perro en cuestion tiene criadores
        if (dogData.breeders.length > 0) {
          agregarListaCriador(dogData.breeders, dog.dogId, this.listaCriadores);
        } else {
          this.listaInscritosSinCriador = this.listaInscritosSinCriador.filter(
            (x) => x !== dogData.id
          );
          this.listaInscritosSinCriador.push(dogData.id);
        }
      });
    },
  },
  computed: {
    /* propiedad para saber los perros que hay para inscribir */
    compNumDogsGrupoCria() {
      if (this.datosNormalizados.length < 3) {
        return 0;
      } else {
        return this.datosNormalizados.length;
      }
    },
    compHayGruposWeb() {
      console.log(this.gruposApi);
      return true;
      if (this.gruposApi.length === 0) {
        return false;
      }
      /*  for (let i = 0; i < this.gruposApi.length; i++) {
        const element = this.gruposApi[i];
        if (element.dogs.length > 2) {
          return true;
          break;
        }
      } */
      return false;
    },
  },
  filters: {
    /* para generar los nombres de los criadores */
    criadoresNombre: function (value, misCriadores) {
      // console.log(value, misCriadores);
      return value;

      if (value.includes("-")) {
        const criadores = value.split("-");
        let nombres = [];
        criadores.forEach((e) => {
          const tmpNombre = misCriadores.find((c) => c.id === parseInt(e));
          nombres.push(tmpNombre.name + " " + tmpNombre.lastname);
        });
        return nombres.join(", ");
      } else {
        // console.log(misCriadores);
        const tmpNombre = misCriadores.find((c) => c.id === parseInt(value));
        // console.log(tmpNombre);
        return tmpNombre.name + " " + tmpNombre.lastname;
      }
      return value;
    },
    nombrePerro: function (dog, listaPerros) {
      const perro = listaPerros.find((p) => p.id === dog);
      return perro.name;
    },
  },
  mounted() {
    // console.log(this.datos, this.datosNormalizados);
    /* Guardamos los datos de los perros para poder mostrarlos */
    this.listaPerros = _.cloneDeep(this.datos.userData.dogs);
    /* Generamos un array con la lista de criadores de los perros inscritos */
    const dogsId = this.datosNormalizados.map((d) => d.dogId);
    /* generamos los grupos agrupados raza/criadores */
    this.getListaGrupoCria(dogsId).then((res) => {
      const tmpGrupos = _.groupBy(_.cloneDeep(res.data.grupos), "criadores");
      this.misCriadores = _.cloneDeep(res.data.criadores_user);
      this.tarifas = _.cloneDeep(res.data.tarifas);
      // console.log(res.data.criadores_user, this.misCriadores);
      const datosGuardados = this.datos.datosGrupoCria;
      const salida = generarGrupoCria(res.data.grupos, datosGuardados);
      this.gruposApi = salida;
      this.generarDatosEmitir();
      this.isLoading = false;
    });

    this.generarListaCriadores();
  },
};

/* funcion para generar las listas de los grups de cria */
const generarGrupoCria = (gruposApi, datosGuardados) => {
  // reglas
  //minimo 3 max 5 ejemplares de misma raza y variedad inscritos en otras categorias
  //mismo criador/es
  //Opcion de añadir un perro de un 3ro de otro titular siempre y cuando el que lo inscriba sea copropietario

  //comprobamos si hay datos guardados
  //console.log("datos guardados ", _.cloneDeep(datosGuardados));
  if (!!datosGuardados && datosGuardados.length > 0) {
    //iteramos por los datos Guardados y comparamos con lo que nos viene de la api y actualizamos
    for (const grupo in datosGuardados) {
      const { raza, grupoCriador, dogs, grupoNum } = datosGuardados[grupo];
      gruposApi.forEach((g) => {
        if (dogs.includes(g.dog_id)) {
          g.grupo = grupoNum;
        }
      });
    }
  }
  //pasamos a null todos los que no tengan grupo
  gruposApi.forEach((g) => {
    //console.log(g, g.grupo, !g.grupo);
    if (!g.grupo) {
      g.grupo = null;
    }
  });
  //console.log("gruposApi modificado ", _.cloneDeep(gruposApi));
  //mapeamos el num de grupos
  const numGrupos = _.uniq(gruposApi.map((g) => g.grupoInscrito));
  const sal = gruposApi.reduce((acc, curr) => {
    //si no existe el obj con la raza lo creamos
    if (!acc[curr.razaId]) acc[curr.razaId] = {};
    const raza = acc[curr.razaId];
    //si no existe el grupo criador lo creamos
    if (!raza[curr.criadores]) raza[curr.criadores] = [];
    const tmp = curr;
    //añadimos el tag select a false para poder marcarlo
    tmp.selected = [];
    tmp.grupoInscrito = curr.grupo;
    if (curr.grupo !== null) {
      tmp.selected[curr.grupo - 1] = true;
    }
    //agregamos el perro a su grupo raza/criador
    raza[curr.criadores].push(tmp);
    return acc;
  }, Object.create(null));

  //console.log(datosGuardados.length);
  for (const raza in sal) {
    const tmp = sal[raza]; 
    
    for (const grupo in tmp) {
      if (tmp[grupo].length < 3) {
        delete tmp[grupo];       
        console.log("raza", raza, tmp, tmp[grupo], Object.keys(tmp).length);
      }
    }
   // console.log(tmp)
   if (Object.keys(tmp).length === 0) delete sal[raza];
  }
  console.log(sal);
  return sal;
};

//const comprobarInscripciones = ()

/* funcion para comprobar si existe ya el criador */
const agregarListaCriador = (criadores, dogId, lista) => {
  //gestionamos los criadores
  let nombre = "";
  let misCriadores = criadores.reduce((acc, val) => {
    const nombre =
      val.name.toUpperCase().trim() + " " + val.lastname.toUpperCase().trim();
    acc.push(nombre);
    return acc;
  }, []);

  //comprobamos el numero de criadores
  if (misCriadores.length === 1) {
    //si hay un unico criador
    nombre = misCriadores[0];
  } else if (misCriadores > 1) {
    //si tenemos mas de un criador
    misCriadores.sort((a, b) => {
      if (a > b) {
        return 1;
      }
      if (a < b) {
        return -1;
      }
      return 0;
    });
    nombre = misCriadores.join(",");
  }

  //si no hay ninguno lo agrego  a la lista
  if (lista.length === 0) {
    const misDogs = [dogId];
    lista.push({ nombre: nombre, dogs: misDogs });
    return;
  }

  //si hay alguno compruebo
  lista.forEach((l) => {
    const filtroDog = l.dogs.filter((x) => x === dogId);
    //  console.log(filtroDog.length, nombre, l.nombre);
    if (l.nombre === nombre) {
      l.dogs.push(dogId);
    }
  });
  return;
};
</script>

<style scoped></style>
